import { render } from "./ChallengeDetails.vue?vue&type=template&id=22a9519f"
import script from "./ChallengeDetails.vue?vue&type=script&lang=js"
export * from "./ChallengeDetails.vue?vue&type=script&lang=js"
script.render = render

export default script